import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BrowserModule } from '@angular/platform-browser';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { CoreCommonModule } from '../../../@core/common.module';
import { CardSnippetModule } from '../../../@core/components/card-snippet/card-snippet.module';
import { ContentHeaderModule } from '../../../app/layout/components/content-header/content-header.module';
import { NouisliderModule } from 'ng2-nouislider';
import { SwiperConfigInterface, SwiperModule, SWIPER_CONFIG } from 'ngx-swiper-wrapper';
import { NgSelectModule } from '@ng-select/ng-select';
import { DashboardComponent } from './dashboard.component';
import { DirectivesModule } from '../directives/directives.module';
import { AuthGuard } from '../../auth/helpers';
import { Role } from 'app/auth/models';
// const DEFAULT_SWIPER_CONFIG: SwiperConfigInterface = {
//   direction: 'horizontal',
//   slidesPerView: 'auto',
//   observer: true
// };

const routes: Routes = [
  {
    path: 'dashboard',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { roles: [Role.User, Role.Admin, Role.Expert]},
  }
];

@NgModule({
  declarations: [DashboardComponent],
  imports: [RouterModule.forChild(routes), NgbModule, ContentHeaderModule, CardSnippetModule, CoreCommonModule, NouisliderModule, 
    SwiperModule,NgSelectModule, DirectivesModule, BrowserModule],
  exports:[DashboardComponent],
  // providers: [
  //   {
  //     provide: SWIPER_CONFIG,
  //     useValue: DEFAULT_SWIPER_CONFIG
  //   }
  // ]
})
export class DashboardModule { }
